import React from "react";
import { Helmet } from "react-helmet-async";

const SEOHead = ({
  title = "GoalFlex - Find & Book Soccer Games Near You",
  description = "Join the ultimate soccer community app. Find pickup games and connect with players in your area. Download GoalFlex and get back on the field today!",
  keywords = "soccer app, pickup soccer, football games, soccer community, recreational soccer, soccer players, pickup football, soccer matches, Minnesota soccer",
  image = "https://goalflex.net/logo512.png",
  url = "https://goalflex.net",
  type = "website",
  structuredData = null,
}) => {
  // Default structured data for organization
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://goalflex.net/#organization",
        name: "GoalFlex",
        url: "https://goalflex.net",
        logo: {
          "@type": "ImageObject",
          url: "https://goalflex.net/logo512.png",
          width: 512,
          height: 512,
        },
        description:
          "Join the ultimate soccer community app. Find pickup games and connect with players in your area.",
        foundingDate: "2024",
        sameAs: [
          "https://apps.apple.com/us/app/goalflex/id6745612755",
          "https://play.google.com/store/apps/details?id=com.goalflex.app",
        ],
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+1-555-GOALFLEX",
          contactType: "Customer Service",
        },
      },
      {
        "@type": "WebSite",
        "@id": "https://goalflex.net/#website",
        url: "https://goalflex.net",
        name: "GoalFlex",
        description:
          "Find pickup soccer games and connect with players in your area.",
        publisher: {
          "@id": "https://goalflex.net/#organization",
        },
        potentialAction: [
          {
            "@type": "SearchAction",
            target: {
              "@type": "EntryPoint",
              urlTemplate: "https://goalflex.net/search?q={search_term_string}",
            },
            "query-input": "required name=search_term_string",
          },
        ],
      },
      {
        "@type": "MobileApplication",
        name: "GoalFlex",
        operatingSystem: ["iOS", "Android"],
        applicationCategory: "SportsApplication",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.8",
          reviewCount: "250",
        },
        offers: {
          "@type": "Offer",
          price: "0",
          priceCurrency: "USD",
        },
        downloadUrl: [
          "https://apps.apple.com/us/app/goalflex/id6745612755",
          "https://play.google.com/store/apps/details?id=com.goalflex.app",
        ],
      },
    ],
  };

  const finalStructuredData = structuredData || defaultStructuredData;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="GoalFlex" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      <meta property="twitter:site" content="@goalflexapp" />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(finalStructuredData)}
      </script>
    </Helmet>
  );
};

export default SEOHead;
